import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Box, Typography, Chip, IconButton, Hidden, Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import Image from '../../../common/Image';
import CoverMessage from '../../../common/CoverMessage';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    media: {
        display: 'flex',
        marginBottom: theme.spacing(2),
    },
    mediaLeft: {
        marginRight: theme.spacing(2),
    },
    mediaContent: {
        flex: 1,
    },
    image: {
        width: 48,
        height: 48,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
    },
    title: {
        fontWeight: 500,
        marginBottom: theme.spacing(0.5),
    },
    companyName: {
        fontSize: '1rem',
        color: theme.palette.text.secondary,
    },
    tags: {
        '& > *': {
            margin: theme.spacing(0, 1, 0, 0),
        },
    },
    areaTag: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
    },
    categoryTag: {
        backgroundColor: '#ffdd57',
        color: '#066298',
    },
    cardContent: {
        position: 'relative',
        '&:last-child': {
            paddingBottom: theme.spacing(2),
        },
    },
    deleteButton: {
        position: 'absolute',
        top: '50%',
        right: theme.spacing(2),
        transform: 'translateY(-50%)',
        color: theme.palette.error.main,
        padding: theme.spacing(1.5),
        '&:hover': {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.dark,
        },
    },
    deleteButtonPC: {
        position: 'absolute',
        top: '50%',
        right: theme.spacing(2),
        transform: 'translateY(-50%)',
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.light,
        },
    },
    deleteIcon: {
        fontSize: '2.4rem',
    },
    deleteText: {
        marginLeft: theme.spacing(1),
        fontSize: '1.8rem',
    },
}));

export default function SavedJobItem({ savedJob, onDelete }) {
    const classes = useStyles();

    const renderCoverMessage = status => {
        let message = null;
        switch (status) {
            case 'inactive':
                message = '募集一時停止中';
                break;
            case 'removed':
                message = '広告削除済';
                break;
            default:
                break;
        }
        if (message) {
            return <CoverMessage message={message} />;
        }
    };

    const handleDelete = (e) => {
        e.preventDefault(); // Prevent link navigation when clicking delete
        onDelete(savedJob._id);
    };

    return (
        <Card className={classes.root} elevation={1}>
            <CardContent className={classes.cardContent}>
                <Hidden smDown>
                    <Button
                        className={classes.deleteButtonPC}
                        onClick={handleDelete}
                        startIcon={<DeleteIcon size="medium" className={classes.deleteIcon} />}
                        aria-label="削除"
                    >
                        <span className={classes.deleteText}>削除</span>
                    </Button>
                </Hidden>
                <Hidden mdUp>
                    <IconButton
                        className={classes.deleteButton}
                        onClick={handleDelete}
                        size="medium"
                        aria-label="削除"
                    >
                        <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                </Hidden>
                <Box className={classes.media}>
                    <Box className={classes.mediaContent}>
                        <Typography className={classes.title} component="h2">
                            {savedJob.jobTitle}
                        </Typography>
                        <Typography className={classes.companyName}>
                            {savedJob.employerName}
                        </Typography>
                    </Box>
                </Box>
                <Box className={classes.tags}>
                    <Chip
                        label={savedJob.areaName ? savedJob.areaName : 'エリア未設定'}
                        className={classes.areaTag}
                        size="small"
                    />
                    <Chip
                        label={savedJob.jobCategory}
                        className={classes.categoryTag}
                        size="small"
                    />
                </Box>
            </CardContent>
            {renderCoverMessage(savedJob.jobStatus)}
        </Card>
    );
}
